import { render, staticRenderFns } from "./link-field-table.vue?vue&type=template&id=ecbb1dca"
import script from "./link-field-table.vue?vue&type=script&lang=js"
export * from "./link-field-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports